import { useTranslation } from 'react-i18next'
import { YeekeeMaltaResultProps } from './YeekeeMaltaResult.types'
import Signature from '../Signature/Signature'

import { useThemeFeatures } from '../../../hooks/useThemeFeatures'
import ComponentHeader from '../ComponentHeader/ComponentHeader'
import PanelSurface from '../PanelSurface/PanelSurface'

//  TODO Robert : Redesign this one.
const YeekeeMaltaResult: React.FC<YeekeeMaltaResultProps> = ({
  signature,
  encryptRawResult,
  rawResult,
  encryptResult,
}) => {
  const { t } = useTranslation()
  const themeFeatures = useThemeFeatures()
  return (
    <PanelSurface
      className={`overflow-hidden ${themeFeatures.rulesHeaderPadding ? 'p-4' : ''}`}
    >
      {/* Header */}
      <ComponentHeader>{t('yeekeeResult.summary')}</ComponentHeader>

      {/* Content */}
      <div
        className={`p-5 ${
          themeFeatures.yeekeeResultAlignment
            ? 'max-w-5xl mx-auto flex flex-col sm:flex-row justify-between space-y-6 sm:space-y-0'
            : 'flex flex-col items-center space-y-6'
        }`}
      >
        {/* Result Numbers Section */}
        <div className="text-center space-y-4">
          <h5 className="text-[var(--caption-text)] text-base font-medium">
            {t('betResult.result')}
          </h5>
          <div className="flex justify-center gap-2">
            {rawResult?.split('')?.map((number, index) => (
              <div
                key={index}
                className="result-number result-number-style font-ibm-plex-sans-thai text-2xl md:text-3xl font-bold shadow-lg"
              >
                {number}
              </div>
            ))}
          </div>
        </div>

        {/* Signature, Raw Result, and Encrypted Results Section  - dynamic alignament*/}

        <div
          className={` ${
            themeFeatures.yeekeeResultAlignment
              ? 'flex flex-col gap-2 yeekee-malta-info-box rounded-lg p-4'
              : 'grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4'
          }`}
        >
          {/* Signature Section */}
          <div className="rounded-lg">
            <Signature signature={signature} />
          </div>

          {/* Raw Result Section */}
          <div className="rounded-lg">
            <div className="px-6">
              <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-center">
                {t('betResult.encrypt_raw_result')}
              </h5>
              <div className="flex flex-col items-center">
                <div
                  className={
                    themeFeatures.yeekeeResultAlignment
                      ? 'inline-flex '
                      : 'inline-flex px-4 py-3 btn-active-state rounded-full border border-[var(--bet-type-active-border)]'
                  }
                >
                  <span className="text-[var(--body-text)] text-base font-medium font-mono break-all">
                    {encryptRawResult}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Encrypted Result Section */}
          <div className="rounded-lg">
            <div className="px-6">
              <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-center">
                {t('betResult.encrypt_result')}
              </h5>
              <div className="flex flex-col items-center">
                <div
                  className={
                    themeFeatures.yeekeeResultAlignment
                      ? 'inline-flex '
                      : 'inline-flex px-4 py-3 btn-active-state rounded-full border border-[var(--bet-type-active-border)]'
                  }
                >
                  <span className="text-[var(--body-text)] text-base font-medium font-mono break-all">
                    {encryptResult}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelSurface>
  )
}

export default YeekeeMaltaResult
